var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivRT" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          return _vm.cerrarOperacion()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.esEdicion
                            ? "Editar Tipo de Licencia"
                            : "Ver Detalle Tipo de Licencia"
                        ) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.e1 != 1,
                                  expression: "e1 != 1"
                                }
                              ],
                              staticClass: "btn-volver",
                              attrs: {
                                disabled: _vm.e1 <= 1 || _vm.btnBloquear
                              },
                              on: {
                                click: function($event) {
                                  _vm.e1 -= 1
                                  _vm.btnText = "Continuar"
                                  _vm.btnClass = "btn-continuar"
                                }
                              }
                            },
                            [_vm._v("Volver")]
                          )
                        : _vm._e(),
                      _vm._v("  \n          "),
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm || _vm.btnBloquear
                                    ? true
                                    : false
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass: "h2_title",
                                              staticStyle: {
                                                "margin-top": "12px!important",
                                                "font-weight": "normal"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Información General\n                    "
                                              )
                                            ]
                                          ),
                                          _c("v-divider")
                                        ],
                                        1
                                      ),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Código",
                                                  counter: 80,
                                                  type: "text",
                                                  disabled: true,
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.id,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "id",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.id"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|ClaseUnicoEditar|max:80",
                                                    expression:
                                                      "'required|ClaseUnicoEditar|max:80'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Clase",
                                                  counter: 80,
                                                  "error-messages": _vm.errors.collect(
                                                    "claseLicencia"
                                                  ),
                                                  "data-vv-name":
                                                    "claseLicencia",
                                                  disabled: !_vm.esEdicion,
                                                  type: "text",
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.clase,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "clase",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "editedItem.clase"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required|max:80",
                                                    expression:
                                                      "'required|max:80'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Nombre",
                                                  counter: 80,
                                                  "data-vv-name": "nombre",
                                                  type: "text",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "nombre"
                                                  ),
                                                  required: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.nombre,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "nombre",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.nombre"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "max:200",
                                                    expression: "'max:200'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Descripción",
                                                  counter: 200,
                                                  "data-vv-name": "descripcion",
                                                  type: "text",
                                                  disabled: !_vm.esEdicion,
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  )
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-select", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  items: _vm.estados,
                                                  label: "Estado",
                                                  "item-value": "id",
                                                  "item-text": "nombre",
                                                  "error-messages": _vm.errors.collect(
                                                    "estado"
                                                  ),
                                                  "data-vv-name": "estado",
                                                  required: "",
                                                  disabled: !_vm.esEdicion,
                                                  "no-data-text":
                                                    "Sin resultados",
                                                  "persistent-hint": "",
                                                  hint: _vm.warningInactivo
                                                },
                                                on: {
                                                  change: _vm.selectedEstado
                                                },
                                                model: {
                                                  value: _vm.editedItem.estado,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "estado",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.estado"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Tipo de Licencia",
            nombreEntidad: _vm.editedItem.nombre
          }),
          mensaje: _vm.mensajeConfirmacionInactivo,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar"),
          width: 450
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }